<template>
  <div class="pickup-filters-list">
    <div class="pickup-filters-list__group">
      <div class="pickup-filters-list__group-label">
        Тип
      </div>

      <div class="pickup-filters-list__group-list">
        <ui-checkbox
          :value="value.store"
          label="Магазин"
          @input="onInput('store', $event)"
        />

        <ui-checkbox
          :value="value.terminal"
          label="Постамат"
          @input="onInput('terminal', $event)"
        />

        <ui-checkbox
          :value="value.pickup"
          label="ПВЗ"
          @input="onInput('pickup', $event)"
        />
      </div>
    </div>

    <div class="pickup-filters-list__group">
      <div class="pickup-filters-list__group-label">
        Услуги
      </div>

      <div class="pickup-filters-list__group-list">
        <ui-checkbox
          :value="value.fitting"
          label="Есть примерка"
          @input="onInput('fitting', $event)"
        />

        <ui-checkbox
          :value="value.returns"
          label="Есть возврат"
          @input="onInput('returns', $event)"
        />

        <ui-checkbox
          :value="value.cardPay"
          label="Оплата картой"
          @input="onInput('cardPay', $event)"
        />

        <ui-checkbox
          :value="value.dayAndNight"
          label="Круглосуточно"
          @input="onInput('dayAndNight', $event)"
        />

        <ui-checkbox
          :value="value.withoutPrepay"
          label="Без предоплаты"
          @input="onInput('withoutPrepay', $event)"
        />

        <ui-checkbox
          :value="value.withoutQrCode"
          label="Без QR-кода"
          @input="onInput('withoutQrCode', $event)"
        />
      </div>
    </div>

    <button
      v-if="countActiveFilters"
      class="pickup-filters-list__reset-btn"
      @click="resetFilters"
    >
      Сбросить фильтры
    </button>
  </div>
</template>

<script>
import { getActiveFiltersCount } from '@/components/checkout/delivery-selector/pickup-filters/utils';
import { defaultFilters } from '@/components/checkout/delivery-selector/pickup-filters/constants';

export default {
  name: 'pickup-filters-list',

  props: {
    value: {
      type: Object,
      default: () => ({ ...defaultFilters }),
    },
  },

  computed: {
    countActiveFilters() {
      return getActiveFiltersCount(this.value);
    },
  },

  methods: {
    onInput(key, value) {
      this.$emit('input', {
        ...this.value,
        [key]: value,
      });
    },

    resetFilters() {
      this.$emit('input', { ...defaultFilters });
    },
  },
};
</script>

<style lang="scss">
.pickup-filters-list {
  display: flex;
  flex-direction: column;
  width: 100%;

  &__group-label {
    margin: 8px 12px;
    font-size: 14px;
    line-height: 24px;
    color: $gray;
  }

  &__group-list {
    display: flex;
    flex-direction: column;

    .ui-checkbox {
      display: flex;
      align-items: center;
      padding: 16px;

      &-label {
        margin-left: 12px;
        padding: 0;
        line-height: 24px;
      }
    }
  }

  &__reset-btn {
    display: none;
  }
}

@include breakpoint("desktop") {
  .pickup-filters-list {
    position: relative;
    flex-direction: row;

    &__group {
      & + & {
        margin-left: 52px;
      }
    }

    &__group-label {
      margin: 0 9px 8px;
      font-weight: 600;
      color: $black;
    }

    &__group-list {
      flex-wrap: wrap;
      max-height: 100%;

      .ui-checkbox {
        padding: 8px;
        margin-right: 44px;
      }
    }

    &__reset-btn {
      position: absolute;
      top: 19px;
      right: 16px;
      display: block;
      padding: 0;
      background: none;
      color: $blue;
      font-size: 14px;
      line-height: 24px;
      cursor: pointer;
    }
  }
}
</style>
